import { Separator } from '@talentmesh/ui/components/separator';
import { TypographyMuted } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

function EndOfListMessage() {
    return (
        <div className="mt-10 flex w-full items-center justify-center px-4">
            <div className="flex w-full max-w-md min-w-64 items-center gap-4">
                <Separator className="flex-1 shrink" />
                <TypographyMuted className="shrink-0">{UIStrings.NoMoreRecruitmentsToShow}</TypographyMuted>
                <Separator className="flex-1 shrink" />
            </div>
        </div>
    );
}

export default EndOfListMessage;
